var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "app-side-menu",
    { attrs: { "min-width": 18, "fixed-menu": false } },
    [
      _c(
        "aside",
        {
          staticClass: "menu",
          attrs: { slot: "side-menu" },
          slot: "side-menu",
        },
        [
          _c("p", { staticClass: "menu-label" }, [
            _c("span", { staticClass: "title is-6" }, [
              _vm._v(" " + _vm._s(_vm.entityName) + " "),
            ]),
          ]),
          _c("ul", { staticClass: "menu-list" }, [
            _c(
              "li",
              [
                _c(
                  "router-link",
                  {
                    class: {
                      "tooltip is-tooltip-danger is-tooltip-right":
                        !_vm.validDetailGroup,
                    },
                    attrs: {
                      to: {
                        name: _vm.routeTypes.CustomerDetail.name,
                        query: _vm.$route.query,
                      },
                      "active-class": "is-active",
                      "data-tooltip": [
                        !_vm.validDetailGroup ? "Validation errors" : "",
                      ],
                      exact: "",
                    },
                  },
                  [
                    _c(
                      "span",
                      {
                        class: {
                          "has-badge-danger has-badge-small has-badge-rounded has-badge-offset2":
                            !_vm.validDetailGroup,
                        },
                        attrs: {
                          "data-badge": !_vm.validDetailGroup ? "" : null,
                        },
                      },
                      [_vm._v(" Detail Info ")]
                    ),
                  ]
                ),
              ],
              1
            ),
            _c(
              "li",
              [
                _c(
                  "router-link",
                  {
                    class: {
                      "tooltip is-tooltip-danger is-tooltip-right":
                        _vm.$v.addressesGroup.$error,
                    },
                    attrs: {
                      to: {
                        name: _vm.routeTypes.CustomerAddress.name,
                        query: _vm.$route.query,
                      },
                      "active-class": "is-active",
                      "data-tooltip": [
                        _vm.$v.addressesGroup.$error ? "Validation errors" : "",
                      ],
                      exact: "",
                    },
                  },
                  [
                    _c(
                      "span",
                      {
                        class: {
                          "has-badge-danger has-badge-small has-badge-rounded has-badge-offset2":
                            _vm.$v.addressesGroup.$error,
                        },
                        attrs: {
                          "data-badge": _vm.$v.addressesGroup.$error
                            ? ""
                            : null,
                        },
                      },
                      [_vm._v(" Addresses ")]
                    ),
                  ]
                ),
              ],
              1
            ),
            _c(
              "li",
              [
                _c(
                  "router-link",
                  {
                    class: {
                      "tooltip is-tooltip-danger is-tooltip-right":
                        _vm.$v.emailsPhonesGroup.$error,
                    },
                    attrs: {
                      to: {
                        name: _vm.routeTypes.CustomerPhoneEmail.name,
                        query: _vm.$route.query,
                      },
                      "active-class": "is-active",
                      "data-tooltip": [
                        _vm.$v.emailsPhonesGroup.$error
                          ? "Validation errors"
                          : "",
                      ],
                      exact: "",
                    },
                  },
                  [
                    _c(
                      "span",
                      {
                        class: {
                          "has-badge-danger has-badge-small has-badge-rounded has-badge-offset2":
                            _vm.$v.emailsPhonesGroup.$error,
                        },
                        attrs: {
                          "data-badge": _vm.$v.emailsPhonesGroup.$error
                            ? ""
                            : null,
                        },
                      },
                      [_vm._v(" Phones/Emails ")]
                    ),
                  ]
                ),
              ],
              1
            ),
            _c(
              "li",
              [
                _c(
                  "router-link",
                  {
                    class: {
                      "tooltip is-tooltip-danger is-tooltip-right":
                        _vm.$v.contactsGroup.$error,
                    },
                    attrs: {
                      to: {
                        name: _vm.routeTypes.CustomerContact.name,
                        query: _vm.$route.query,
                      },
                      "active-class": "is-active",
                      "data-tooltip": [
                        _vm.$v.contactsGroup.$error ? "Validation errors" : "",
                      ],
                      exact: "",
                    },
                  },
                  [
                    _c(
                      "span",
                      {
                        class: {
                          "has-badge-danger has-badge-small has-badge-rounded has-badge-offset2":
                            _vm.$v.contactsGroup.$error,
                        },
                        attrs: {
                          "data-badge": _vm.$v.contactsGroup.$error ? "" : null,
                        },
                      },
                      [_vm._v(" Contacts ")]
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }